import { render } from "./LP-THLSprueche.vue?vue&type=template&id=de03dd14&scoped=true"
import script from "./LP-THLSprueche.vue?vue&type=script&lang=js"
export * from "./LP-THLSprueche.vue?vue&type=script&lang=js"

import "./LP-THLSprueche.vue?vue&type=style&index=0&id=de03dd14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de03dd14"]])

export default __exports__